import { all, call, put, takeEvery } from "redux-saga/effects";
import HeatmapActionTypes from "../../constants/Applications/heatMap-actionTypes";
import { getHeatmapDropdownDataService, getHeatmapFormTableDataService, getHeatmapTableDataService, getVishingDropdownDataService, getVishingFormTableDataService, getVishingValidateTicketNoService, updateHeatmapFormDataService, updateVishingFormDataService } from "../../services/Applications/heatmap.service";
import HeatmapURLs from "../../constants/Applications/heatmap-urls";
import { updateHeatmapFormDataSuccess, updateVishingFormDataSuccess } from "../../actions/Applications/heatmap.action";

function* fetchHeatmapTableData({data}) {
  const items =  {
    data: data,
}
    try {
        const response = yield call(getHeatmapTableDataService, HeatmapURLs('GET_HEATMAP_TABLE_DATA',items));
        console.log("Fetching Heatmap Table Data API is success");
        console.log(response);
        if (response.data) {
            yield put({
                type: HeatmapActionTypes.HEATMAP_TABLE_DATA,
                payload: response.data,
            });
        }
    } catch (error) {
        console.log("Error while fetching Heatmap Table Data");
        console.log(error);
    }
}

function* fetchHeatmapDropdownData({roleId}) {
    const items =  {
    roleId: roleId,  
}
    try {
        const response = yield call(getHeatmapDropdownDataService, HeatmapURLs('GET_HEATMAP_DROPDOWN_DATA',items));
        console.log("Fetching Heatmap Dropdown Data API is success");
        console.log(response);
        if (response.data) {
            yield put({
                type: HeatmapActionTypes.HEATMAP_DROPDOWN_DATA,
                payload: response.data,
            });
        }
    } catch (error) {
        console.log("Error while fetching Heatmap Dropdown Data");
        console.log(error);
    }
}

 function* updateHeatmapFormData({ payload: id ,callback}) {
      try {
          const response = yield call(updateHeatmapFormDataService, HeatmapURLs('UPDATE_HEATMAP_FORM_DATA'), id);
          if (response.data) {
              yield put(
                updateHeatmapFormDataSuccess()
              );
              console.log(response.data)
               if (callback && typeof callback === 'function') {
        callback(); 
      }
          }
      } catch (error) {
          console.log("Error while updating heatmap form Data", error);
      }
  }

  function* fetchHeatmapFormTableData({customerId,toolId,servicedeskId}) {
  const items =  {
    customerId: customerId,
    toolId: toolId,
    servicedeskId: servicedeskId
}
    try {
        const response = yield call(getHeatmapFormTableDataService, HeatmapURLs('GET_HEATMAP_FORM_TABLE_DATA',items));
        console.log("Fetching Heatmap Form Table Data API is success");
        console.log(response);
        if (response.data) {
            yield put({
                type: HeatmapActionTypes.HEATMAP_FORM_TABLE_DATA,
                payload: response.data,
            });
        }
    } catch (error) {
        console.log("Error while fetching Heatmap Form Table Data");
        console.log(error);
    }
}

function* fetchVishingDropdownData({roleId}) {
    const items =  {
    roleId: roleId,  
}
    try {
        const response = yield call(getVishingDropdownDataService, HeatmapURLs('GET_VISHING_DROPDOWN_DATA',items));
        console.log("Fetching Vishing Dropdown Data API is success");
        console.log(response);
        if (response.data) {
            yield put({
                type: HeatmapActionTypes.VISHING_DROPDOWN_DATA,
                payload: response.data,
            });
        }
    } catch (error) {
        console.log("Error while fetching Vishing Dropdown Data");
        console.log(error);
    }
}

 function* updateVishingFormData({ payload: id ,callback}) {
      try {
          const response = yield call(updateVishingFormDataService, HeatmapURLs('UPDATE_VISHING_FORM_DATA'), id);
          if (response.data) {
              yield put(
                updateVishingFormDataSuccess()
              );
              console.log(response.data)
               if (callback && typeof callback === 'function') {
        callback(); 
      }
          }
      } catch (error) {
          console.log("Error while updating Vishing form Data", error);
      }
  }

   function* fetchVishingFormTableData() {
  
    try {
        const response = yield call(getVishingFormTableDataService, HeatmapURLs('GET_VISHING_FORM_TABLE_DATA'));
        console.log("Fetching Vishing Form Table Data API is success");
        console.log(response);
        if (response.data) {
            yield put({
                type: HeatmapActionTypes.VISHING_FORM_TABLE_DATA,
                payload: response.data,
            });
        }
    } catch (error) {
        console.log("Error while fetching Vishing Form Table Data");
        console.log(error);
    }
}

function* fetchVishingValidateTicketNo({ticketNo}) {
    const items =  {
    ticketNo: ticketNo,  
}
  
    try {
        const response = yield call(getVishingValidateTicketNoService, HeatmapURLs('GET_VISHING_VALIDATE_TICKET_NO',items));
        console.log("Fetching Vishing validate Ticket API is success");
        console.log(response);
        if (response.data) {
            yield put({
                type: HeatmapActionTypes.VISHING_VALIDATE_TICKET_NO,
                payload: response.data,
            });
        }
    } catch (error) {
        console.log("Error while fetching Vishing validate Ticket API Data");
        console.log(error);
    }
}

function* watchGetRequest() {
    yield takeEvery(HeatmapActionTypes.GET_HEATMAP_TABLE_DATA, fetchHeatmapTableData);
    yield takeEvery(HeatmapActionTypes.GET_HEATMAP_DROPDOWN_DATA, fetchHeatmapDropdownData);
    yield takeEvery(HeatmapActionTypes.UPDATE_HEATMAP_FORM_DATA_START, updateHeatmapFormData);
    yield takeEvery(HeatmapActionTypes.GET_HEATMAP_FORM_TABLE_DATA, fetchHeatmapFormTableData);
    yield takeEvery(HeatmapActionTypes.GET_VISHING_DROPDOWN_DATA, fetchVishingDropdownData);
    yield takeEvery(HeatmapActionTypes.UPDATE_VISHING_FORM_DATA_START, updateVishingFormData);
    yield takeEvery(HeatmapActionTypes.GET_VISHING_FORM_TABLE_DATA, fetchVishingFormTableData);
    yield takeEvery(HeatmapActionTypes.GET_VISHING_VALIDATE_TICKET_NO, fetchVishingValidateTicketNo);


}

export default function* heatmapSagas() {
    yield all([watchGetRequest()]);
}